// extracted by mini-css-extract-plugin
export default {"newsletter":"NewsletterSignup_newsletter__DvCmm"};